import { ChatMessage, ErrorInfo } from "../types";

export const buildErrorMessage = (errorInfo: ErrorInfo): ChatMessage => ({
  content: errorInfo.error,
  role: "assistant",
  error: true,
  errorType: errorInfo.errorType,
  isTruncated: false,
});
